// extracted by mini-css-extract-plugin
export default {"token-info-card":"Tokenizer_token-info-card__2ht1g"};